// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__oWjJP","dragIcon":"Choice_dragIcon__VI2nZ","left":"Choice_left__3cK4x","input":"Choice_input__1MJVL"};